/**
 * Tutorial guidato dell'elenco Metodi di spedizione.
 *
 * Il piu' in alto porta dritto alla pagina della scheda. I tre pallini della riga
 * si raccontano illuminando il pulsante, non la voce dentro il menu: aprire un menu di Vuetify dal tutorial non e'
 * affidabile, perche' il click programmatico e quello su "Avanti" arrivano a
 * `document` a un soffio di distanza e il menu appena aperto legge il secondo come
 * un click fuori. Il pulsante invece c'e' sempre, e il testo dice cosa contiene.
 */
const SCOPE = '[data-tour-scope="shipping-methods"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

/** Nessun preparativo: niente da rimettere a posto a fine giro. */
export function stopShippingMethodsTour() {}

export function createShippingMethodsTourSteps() {
	return [
		{
			body: 'I metodi di spedizione sono le voci che il cliente si trova davanti alla cassa: il corriere espresso, la posta, il ritiro in negozio. Qui si dice solo che esistono e come si chiamano; quanto costano lo dicono i Costi di spedizione, che si agganciano al metodo scelto qui.',
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'I metodi di spedizione',
		},
		{
			body: "Il piu' in alto porta dritto alla pagina del nuovo metodo: li' si scrive il nome per ogni lingua e si possono aggiungere le regole di spedizione a prezzo fisso. Annulla riporta qui con l'elenco come l'avevi lasciato. La pagina ha un tutorial suo.",
			key: 'add',
			placement: 'left',
			target: at('add'),
			title: 'Aggiungere un metodo',
		},
		{
			body: "L'elenco e' corto per natura: stato, data di creazione e nome nella lingua predefinita. I metodi sono pochi e cambiano di rado - e' il listino dei costi a essere lungo, non questo.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: "L'interruttore accende e spegne il metodo, e salva subito. Spento sparisce dalla cassa anche se i suoi costi di spedizione restano scritti: e' il modo per sospendere un corriere senza cancellare il listino che gli hai costruito intorno.",
			key: 'switch',
			placement: 'right',
			target: at('switch'),
			title: 'Accendere il metodo',
		},
		{
			body: "I tre pallini aprono Modifica, che porta alla pagina del metodo, ed Elimina, che chiede conferma. Prima di eliminare un metodo vale la pena guardare i Costi di spedizione: le righe che lo riguardano restano li' senza un metodo a cui appartenere, e vanno ripulite a mano.",
			key: 'row-menu',
			placement: 'right',
			target: at('row-menu'),
			title: 'Modificare o eliminare',
		},
		{
			body: "L'elenco arriva una pagina per volta dal server: da qui cambi pagina e quante righe vedere. Pagina, righe e ordinamento restano nell'indirizzo: ricaricando o tornando da una scheda li ritrovi.",
			key: 'pagination',
			placement: 'top',
			target: `${SCOPE} .v-data-footer`,
			timeout: 400,
			title: "Sfogliare l'elenco",
		},
	];
}
